<template>
  <!-- 自定义类型分享 -->
  <van-popup v-model="showShare" class="share-mask" position="bottom" :close-on-click-overlay="false" @click-overlay="handleCancleShare">
    <div class="share-box">
      <div class="share-content">
        <div v-show="showShareFriend" class="share-item">
          <img src="../assets/images/share/weixin.png" alt="" @click.stop="handleShare(0)">
          <p>微信</p>
        </div>
        <div class="share-item">
          <img src="../assets/images/share/friend.png" alt="" @click.stop="handleShare(1)">
          <p>朋友圈</p>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import { Popup } from 'vant'
export default {
  components: {
    [Popup.name]: Popup
  },
  props: {
    shareData: {
      type: Object,
      default: () => (
        {
          title: null,
          content: null,
          image: null,
          urlStr: null
        }
      )
    },
    showShare: {
      type: Boolean,
      default: false
    },
    showShareFriend: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleCancleShare () {
      this.$emit('cancleShare')
    },
    handleShare (type) {
      this.$emit('share', type)
    }
  }
}
</script>
<style lang="scss" scoped>
.share-mask {
  z-index: 100;
}
.share-box {
  background: #fff;
  padding: 25px 15px;
}
.share-content {
  margin: 10px;
  display: flex;
  justify-content: space-around;
  .share-item {
    text-align: center;
    font-size: 12px;
    color: #666;
  }
  img {
    width: 40px;
    height: 40px;
  }
}
</style>
